module.exports = __webpack_public_path__ + "img/news.4f83dbe9.png";